import { Box, Chip, Container, Divider, Typography } from '@mui/material';
import { EffectiveServicingDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { LoadingIndicator } from '../../../../ui/components/pure/loading-indicator/loading-indicator.component';
import { formatTransactionType } from '../../../carriers/logic/add-carrier-form';

export interface CarrierGroupPanelProps {
  /** What the group is: the organisation's container, or an operating unit inside it. */
  isOrganisation: boolean;
  servicing: EffectiveServicingDto[];
  isLoading: boolean;
  error?: string;
}

/** Read-only: servicing is granted through its own action, not saved with the form. */
export function CarrierGroupPanel({ isOrganisation, servicing, isLoading, error }: CarrierGroupPanelProps) {
  return (
    <Container style={{ paddingBottom: 24 }}>
      <Box
        sx={{
          marginTop: 2,
          marginBottom: 1
        }}
      >
        <Divider />
      </Box>

      <Typography variant="caption" color="textSecondary">
        Networks
      </Typography>

      {isLoading && <LoadingIndicator />}

      {!isLoading && error && (
        <Typography variant="body2" color="error">
          {error}
        </Typography>
      )}

      {!isLoading && !error && servicing.length === 0 && (
        <Typography variant="body2" color="textSecondary">
          {isOrganisation
            ? 'This carrier services no networks, so it appears on no kiosk.'
            : 'This carrier services no networks. It normally inherits them from its organisation.'}
        </Typography>
      )}

      {!isLoading &&
        !error &&
        servicing.map((grant) => (
          <Box
            key={grant.projectID}
            sx={{
              marginTop: 1
            }}
          >
            <Box
              style={{ gap: 8 }}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography variant="body2">{grant.projectName}</Typography>
              {grant.inheritedFrom && (
                <Chip size="small" variant="outlined" label={`via ${grant.inheritedFrom.name}`} />
              )}
            </Box>
            <Typography variant="caption" color="textSecondary">
              {grant.permissions.map(formatTransactionType).join(', ')}
            </Typography>
          </Box>
        ))}
    </Container>
  );
}
